<template>
  <CornerBox
    :class="{
      'text-gray-500': completed < required,
      'text-green-400': completed === required,
      'text-red-400': completed > required,
      'fading-background': dirty || shouldAnimate
    }"
  >
    <slot>
      <div
        :class="{
          'fading-foreground': dirty || shouldAnimate
        }"
      >
        <span>
          {{ completed }}
        </span>
        <span class="px-0.5">/</span>
        <span>
          {{ required }}
        </span>
      </div>
    </slot>
  </CornerBox>
</template>

<script setup>
import { watch, ref } from 'vue'
import CornerBox from '@/Components/CornerBox.vue'

const props = defineProps({
  completed: {
    type: Number,
    default: undefined
  },
  required: {
    type: Number,
    default: undefined
  },
  dirty: {
    type: Boolean,
    default: false
  }
})

const shouldAnimate = ref(false)

let timer = null

// Animate any time the completed quantity changes.
// However, when this component is used in AG Grid, the component is torn down and re-rendered on each change.
// So we also use "dirty" to trigger animation any time the component is rendered after the initial render.
watch(
  () => props.completed,
  () => {
    if (timer) clearTimeout(timer)

    shouldAnimate.value = true

    timer = setTimeout(() => {
      shouldAnimate.value = false
    }, 800)
  }
)
</script>

<style scoped>
@keyframes fadeBackground {
  0% {
    background-color: #effdf1;
  }
  100% {
    background-color: transparent;
  }
}
.fading-background {
  animation: fadeBackground 800ms forwards;
}

@keyframes fadeForeground {
  0% {
    color: var(--green-400);
  }
  100% {
    color: currentColor;
  }
}
.fading-foreground {
  animation: fadeForeground 500ms forwards;
}
</style>
